import React from 'react';
import { TableHeader, TableRow } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { TableHeadingStyled, TableHeadingNumberStyled } from './styles';
import { CENSUS_TABLE_HEADER_TEST_ID } from '../../../constants';

interface Props {
  headers: string[];
}
const CensusTableHeader: React.FC<Props> = observer(({ headers }) => {
  return (
    <TableHeader data-test-id={CENSUS_TABLE_HEADER_TEST_ID}>
      <TableRow>
        <TableHeadingNumberStyled />
        {headers.map((title) => (
          <TableHeadingStyled key={title}>{title}</TableHeadingStyled>
        ))}
      </TableRow>
    </TableHeader>
  );
});

export default CensusTableHeader;
